import { render, staticRenderFns } from "./AlunosAusentesPage.vue?vue&type=template&id=2278f9ec&scoped=true"
import script from "./AlunosAusentesPage.vue?vue&type=script&lang=js"
export * from "./AlunosAusentesPage.vue?vue&type=script&lang=js"
import style0 from "./AlunosAusentesPage.vue?vue&type=style&index=0&id=2278f9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278f9ec",
  null
  
)

export default component.exports